
import ".././challenges/Challenges.css"
import React from "react";

const Points = ({points}) => {
          return (
    <div class="loyalty-card">
    <h4>Points Balance</h4>
    <div class="points-section">
      <div class="circle">
        🏆
      </div>
      <div class="points-text">
        <h1>{points} pts</h1>
        <p>Collect points by end your challanges</p>
      </div>
    </div>
    </div>
  );
};

export default Points;
